import React, { Suspense, lazy } from "react";
import { Camera } from "lucide-react";
import { Loading } from "./primitives";
import Simple from "./Simple";

// Eagerly-loaded views — landing-page candidates the user is very likely
// to hit on first paint. Keeping these inline avoids a flash-of-loading
// on the most common navigation paths.
import Dashboard from "../views/Dashboard";
import Members from "../views/Members";
import Schedules from "../views/Schedules";
import Availability from "../views/Availability";

// Phase 4 #2 — heavy / less-common views are lazy-loaded so their JS
// only ships when the user actually navigates there. Each view ends up
// in its own chunk (see vite build output).
const Groups        = lazy(() => import("../views/Groups"));
const Teams         = lazy(() => import("../views/Teams"));
const Squads        = lazy(() => import("../views/Squads"));
const Practice      = lazy(() => import("../views/Practice"));
const Rankings      = lazy(() => import("../views/Rankings"));
const Announcements = lazy(() => import("../views/Announcements"));
const Finance       = lazy(() => import("../views/Finance"));
const Admin         = lazy(() => import("../views/Admin"));
const Profile       = lazy(() => import("../views/Profile"));
const Messages      = lazy(() => import("../views/Messages"));
const Notifications = lazy(() => import("../views/Notifications"));
const Splits        = lazy(() => import("../views/Splits"));

export default function Module({ active, setActive, navArg, state, reload, user, setUser }) {
  let view;
  switch (active) {
    case "dashboard":      view = <Dashboard state={state} reload={reload} user={user} navigate={setActive} />; break;
    case "members":        view = <Members state={state} reload={reload} user={user} />; break;
    case "groups":         view = <Groups state={state} reload={reload} user={user} />; break;
    case "teams":          view = <Teams state={state} reload={reload} user={user} />; break;
    case "schedule":       view = <Schedules state={state} reload={reload} user={user} navigate={setActive} />; break;
    case "availability":   view = <Availability state={state} reload={reload} user={user} navigate={setActive} />; break;
    case "squad":          view = <Squads state={state} reload={reload} user={user} navigate={setActive} focusMatchId={navArg} />; break;
    case "practice":       view = <Practice state={state} reload={reload} user={user} />; break;
    case "rankings":       view = <Rankings state={state} reload={reload} user={user} />; break;
    case "announcements":  view = <Announcements state={state} reload={reload} user={user} />; break;
    case "finance":        view = <Finance state={state} reload={reload} user={user} />; break;
    case "media":          view = <Simple title="Media Gallery" icon={Camera}
                                           text="Premium gallery module ready for image/video upload integration." />; break;
    case "notifications":  view = <Notifications state={state} user={user} />; break;
    case "admin":          view = <Admin state={state} reload={reload} user={user} />; break;
    case "profile":        view = <Profile user={user} setUser={setUser} reload={reload} />; break;
    case "messages":       view = <Messages state={state} user={user} />; break;
    case "splits":         view = <Splits state={state} user={user} />; break;
    default:               return null;
  }
  return <Suspense fallback={<Loading label="Loading view…" size="lg" />}>{view}</Suspense>;
}
